import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class UseGuichetGuardService implements CanActivate {
  constructor(public api: ApiService, private router: Router) {}

  canActivate(): boolean {
    if (this.api.env.useGuichet) {
      this.router.navigate(['/dashboard']);
      return false;
    }
    return true;
  }
}